// Lightweight fuzzy matcher for the Log Monitor search suggestions.
// Ranks exact substring matches highest, then in-order subsequence (fuzzy) matches.
// Multi-word queries require EVERY whitespace token to match (AND).

export function fuzzyScore(query: string, text: string): number {
  const q = query.trim().toLowerCase();
  const t = text.toLowerCase();
  if (!q) return 0;

  const idx = t.indexOf(q);
  if (idx !== -1) return 10000 - idx; // exact substring — earlier position ranks higher

  // in-order subsequence match (fuzzy)
  let qi = 0;
  let score = 0;
  let prev = -2;
  for (let ti = 0; ti < t.length && qi < q.length; ti++) {
    if (t[ti] === q[qi]) {
      score += ti === prev + 1 ? 3 : 1; // consecutive-character bonus
      prev = ti;
      qi++;
    }
  }
  return qi === q.length ? score : -1; // -1 => not a match
}

// Filter + rank `options` against the typed `query`. Returns the best matches,
// capped at `limit` to keep the dropdown snappy.
export function fuzzySearch(options: string[], query: string, limit = 50): string[] {
  const q = (query || "").trim();
  if (!q) return []; // no input -> no suggestions (don't dump the whole catalog)

  const tokens = q.split(/\s+/);
  const scored: { opt: string; score: number }[] = [];
  for (const opt of options) {
    let total = 0;
    let matched = true;
    for (const tok of tokens) {
      const s = fuzzyScore(tok, opt);
      if (s < 0) {
        matched = false;
        break;
      }
      total += s;
    }
    if (matched) scored.push({ opt, score: total });
  }
  scored.sort((a, b) => b.score - a.score || a.opt.length - b.opt.length);
  return scored.slice(0, limit).map((s) => s.opt);
}
